module.exports = "https://r.zoocdn.com/_next/static/images/error-no-results-baf9729be5c87d613e918367724babb5.svg";